import { OPEN_CONFIRMATION, CLOSE_CONFIRMATION, UPDATE_DRAWER_NO } from "../constants";

export function setUserTotalTestCount(payload) {
  return { type: "SET_TEST_COUNTS", payload };
}

export function openConfirmation(
  title,
  message,
  onConfirm,
  closable,
  closeButtonTitle,
  confirmButtonTitle,
  onClose = null,
) {
  return {
    type: OPEN_CONFIRMATION,
    payload: { title, message, onConfirm, onClose, closable, closeButtonTitle, confirmButtonTitle },
  };
}

export function closeConfirmation() {
  return {
    type: CLOSE_CONFIRMATION,
  };
}

export function updateDrawerNo(payload) {
  return { type: UPDATE_DRAWER_NO, payload };
}
